/* Sable & Ochre - the free-shipping bar, said in the visitor's own money.
 *
 * HOW THE BAR WORKS (checked against the delivery profiles 2026-10-01):
 *   - EU edition profile: free from 500 SEK. Shopify converts that into the
 *     visitor's currency at the same rate it converts prices, so the honest
 *     number to print is that conversion, done here with the rate Shopify hands
 *     this page (Shopify.currency.rate), rounded UP.
 *   - US edition profile: free from $60, set IN DOLLARS on the zone itself
 *     (Set-UsFreeShippingUsd.ps1, owner's choice 2026-10-01), so no conversion:
 *     "$60" is exactly what checkout does, whatever the exchange rate.
 *
 * WHY NOT A TABLE ANY MORE: until 2026-10-01 the snippet and two pages carried
 * fixed per-currency figures (EUR 45, USD 55 or 66, CZK 1100 ...). Rates move and
 * the table did not: on 2026-10-01 the real bars were EUR 45.07, USD 61.10 and
 * CZK 1102.58, so "free over EUR 45" and "free over $55" promised free shipping
 * that checkout would not give. A live conversion cannot drift. Any data-bars
 * attribute still on an element is ignored.
 *
 * ROUND UP, NEVER DOWN: a visitor told "over $61" who reaches $61.05 and is
 * then charged has been promised something checkout will not honour, which is
 * the one failure mode worth engineering against. Rounding to whole units below
 * 100 keeps the over-statement to cents rather than a fiver.
 *
 * WHY NOT DO THIS IN LIQUID: the page cache will serve a page rendered for one
 * country to a visitor in another. Shopify.currency is only reliable at runtime.
 */
(function () {
  'use strict';

  var SEL = '[data-hp-ship-threshold]';

  /* Bars set directly in a currency on the delivery profile, printed as they are.
     Only the US edition ships to customers paying in dollars.
     SOURCE OF TRUTH: Settings > Shipping and delivery > the "US edition" profile's
     Free shipping rate. If that changes in admin, change it here too. */
  var FIXED_BAR = { USD: 60 };

  /* Format in the CURRENCY's own convention, not the browser locale. Intl
     writes a number the way the LOCALE says to, so on an en-GB browser SEK came
     out "SEK 470" while every other price on the page - rendered by Shopify's
     money filter, which follows the shop's format - said "470 kr". */
  var CURRENCY_LOCALE = {
    SEK: 'sv-SE', DKK: 'da-DK', ISK: 'is-IS', EUR: 'en-IE',
    USD: 'en-US', CHF: 'de-CH', CZK: 'cs-CZ'
  };

  function format(amount, currency) {
    try {
      return new Intl.NumberFormat(CURRENCY_LOCALE[currency] || navigator.language || 'en', {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(amount);
    } catch (e) {
      /* Unknown code, or an engine without Intl. Uglier but never wrong. */
      return amount + ' ' + currency;
    }
  }

  /* Whole units below 100 (EUR 46, $62, CHF 43), fives in the hundreds (340 kr),
     tens in the thousands (1 110 Kc, 6 180 kr). The epsilon stops a float like
     500.0000001 from rounding a round number up a whole step. */
  function roundUp(value) {
    var step = value < 100 ? 1 : (value < 1000 ? 5 : (value < 10000 ? 10 : 100));
    return Math.ceil(value / step - 1e-9) * step;
  }

  function paint() {
    var els = document.querySelectorAll(SEL);
    if (!els.length) { return; }

    var S = window.Shopify;
    var money = S && S.currency;
    var active = money && money.active;
    if (!active) { return; }   /* server already rendered the SEK figure */

    var rate = active === 'SEK' ? 1 : parseFloat(money.rate);
    if (!rate || !isFinite(rate) || rate <= 0) { return; }

    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var amount = FIXED_BAR[active];
      if (typeof amount !== 'number') {
        var sek = parseFloat(el.getAttribute('data-sek'));
        if (!sek) { continue; }
        amount = roundUp(sek * rate);
      }

      var text = format(amount, active);
      if (el.textContent !== text) { el.textContent = text; }
    }
  }

  /* For the cart's free-shipping progress line (snippets/so-ship-progress.liquid): the bar
     in the visitor's currency, worked out exactly as above, and the same formatter. */
  window.hpShipBar = function (sekDefault) {
    var S = window.Shopify, money = S && S.currency, active = money && money.active;
    if (!active) { return null; }
    if (typeof FIXED_BAR[active] === 'number') { return { amount: FIXED_BAR[active], currency: active }; }
    var rate = active === 'SEK' ? 1 : parseFloat(money.rate);
    if (!rate || !isFinite(rate) || rate <= 0) { return null; }
    return { amount: roundUp((sekDefault || 500) * rate), currency: active };
  };
  window.hpShipFormat = format;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', paint);
  } else { paint(); }

  /* The theme editor re-renders a section on its own; a repainted announcement
     bar or salon caption would otherwise drop back to the raw SEK figure. */
  document.addEventListener('shopify:section:load', paint);
}());
